export async function triggerRequest() {
  await fetch(`${process.env.REACT_APP_PROG_2035_TRIGGER_URL}`, {
    method: 'POST',
    body: '{}',
  });
}
